import {
  compose,
  withHandlers,
  setStatic,
  branch,
  withProps,
  renderComponent
} from 'recompose'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'

import ContactPage from '../components/Contact'
import NotAuthenticatedContactPage from '../components/Contact/NotAuthenticatedContactPage'
import { withInitialData } from '../components/hoc'
import { postContactForm, getSupportCategories } from '../reducers/contact'

const mapStateToProps = (state, ownProps) => {
  return {
    contactForm: state.form.contact,
    loading: state.contact.loading,
    supportCategories: ownProps.categories
  }
}

const mapDispatchToProps = dispatch => ({
  getSupportCategories: () => dispatch(getSupportCategories()),
  postContactForm: formData => dispatch(postContactForm(formData))
})

export default compose(
  setStatic(
    'getInitialProps',
    async ({ req, reduxStore }) => {
      const isServer = !!req
      try {
        const categories = await reduxStore.dispatch(getSupportCategories())
        return { isServer, categories }
      } catch (err) {
        console.error(err)
        return { err }
      }
    }
  ),
  connect(mapStateToProps, mapDispatchToProps),
  withProps({
    contentImage: ''
  }),
  withInitialData,
  reduxForm({
    form: 'contact',
    destroyOnUnmount: true,
    onSubmitSuccess: (result, dispatch) => dispatch(reset('contact'))
  }),
  withHandlers({
    _handleSubmit: ({ postContactForm, createNotification, t }) => contactForm => {
      postContactForm({
        ...contactForm
      })
        .then(() => {
          createNotification({
            type: 'success',
            message: t('common:email-sent-success')
          })
        })
        .catch(() => {
          createNotification({
            type: 'error',
            message: t('common:email-sent-error')
          })
        })
    }
  }),
  branch(({ isAuthenticated }) => !isAuthenticated, renderComponent(NotAuthenticatedContactPage))
)(ContactPage)



// WEBPACK FOOTER //
// ./pages/contact.js